<template>
  <!--销售员页面 -->
  <div id="myCustomCollections" style="background-color: #F0F0F0;" v-if="showPage">
	&nbsp;
  <!--搜索下拉列表区域-->
  <div class="pushPageAllSearch">
	<div style="height: 70px;">
        <ul>
          <li>
			<span>医院:</span> 
			<select @change="changeSelect($event)" class="pushPageSelect" v-model="cateModel.insId">
                <option :key="index" v-for="(childrenitem, index) in allIns" :value="childrenitem.id" selected>{{childrenitem.name}}</option>
            </select>
			&nbsp;&nbsp;&nbsp;
			<span>科室:</span>
			<select @change="changeSelect($event)" class="pushPageSelect" v-model="cateModel.departmenId">
                <option :key="index" v-for="(childrenitem, index) in allDepartmen" :value="childrenitem.id" selected>{{childrenitem.name}}</option>
            </select>
		  </li>
		  <li style="margin-top:10px;">
			<span>产品:</span> 
			<select @change="changeSelect($event)" class="pushPageSelect" v-model="cateModel.productId">
                <option :key="index" v-for="(childrenitem, index) in allBrand" :value="childrenitem.id" selected>{{childrenitem.name}}</option>
            </select>
		  </li>
        </ul>
      </div>
  </div>
  <!--我的医生信息区域-->
  <div style="margin-top: 10px;background-color:#FFFFFF;text-align:center;border-radius: 10px 10px 10px 10px;margin-left: 10px;margin-right: 10px;" 
  	:key="index" v-for="(item, index) in allDocInfo" >
	<table cellspacing="5" style="height:80px;">
          <tbody>
          <tr>
            <th style="text-align: left;width: 120px;"><font size="4">{{item.docName}}</font></th>
            <td style="text-align: right;width: 140px;"><font size="2">Score {{item.score}}</font></td>
            <td v-if="item.nbc > 0" style="text-align: left;width: 290px;"><font size="2" color="gray" style="background-color:#00FF00;">NBC</font></td>
			<td v-else style="text-align: left;width: 290px;"></td>
            <td colspan="2" rowspan="2"><button style="background-image:url('https://takedamedical.takeda.com.cn/Files/fasong.png');width:60px;height:60px;border:none;" @click="articalPush(item)">
			</button></td>
          </tr>
          <tr>
            <td style="text-align: left;width: 120px;"><font size="2">{{item.department}}</font></td>
            <td style="text-align: left;width: 140px;"><font size="2">{{item.rank}}</font></td>
            <td style="text-align: left;width: 290px;"><font size="2">{{item.hospitalName}}</font></td>
          </tr>
          </tbody>
        </table>
  </div>
  </div>
</template>

<script>
export default {
	name: 'myCustomCollections',
  	data () {
    	return {
			timer:"",
        	allBrand: [
				{
				id: '-1',
				name: '全部'
				}
			],
			allDepartmen: [
				{
				id: '-1',
				name: '全部'
				}
			],
			allIns: [
				{
				id: '-1',
				name: '全部'
				}
			],
			allDocInfo: [],
			returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
			takedacode: this.$route.query.takedacode || '',
			jumptovctag: this.$route.query.jumptovctag || '',
			NewerTag: this.$route.query.NewerTag || '',
			showGuide: false,
			showPage: false,
			openId: '',
			isHcp: false,
			userInfo: {},
			cateModel: {
				insId: '-1',
				departmenId: '-1',
				productId: '-1'
      		}
		}
	},
	created () {

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
	let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myCustomCollections?returnurl=' + encodeURIComponent((this.oriUrl || '')))
			window.location.href = url
 }


      //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
	  if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
	else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }


		if (!localStorage.TaToken && !this.takedacode) {
			let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myCustomCollections?returnurl=' + encodeURIComponent((this.oriUrl || '')))
			window.location.href = url
		} else {
		if (this.takedacode && !localStorage.TaToken) {
			this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
			localStorage.TaToken = msg.token
			localStorage.appId = msg.appId
			localStorage.openId = msg.openId
			this.openId = msg.openId
			let isEmployee = window.localStorage.getItem('isEmployee')
			let allAxiox = ''
			if (isEmployee) {
				let data = {
				openId: this.openId,
				returnurl: encodeURIComponent(this.returnurl)
				}
				allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
			} else {
				let data = {
				openid: this.openId,
				returnurl: encodeURIComponent(this.returnurl)
				}
				allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
			}

			if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}

			allAxiox.then(msg => {
				console.log(msg, 'getDoctor')
				if (msg.isSuccess) {
				if (msg.data.status === 2) {
					//window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
				} else if (msg.data.status === 3) {
					//window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
				} else {
					if (msg.data.isFollowed) {
						// 获取用户信息
						this.getUserInfo()
					} else {
						// this.$commonJs.closeWindow()
						this.showGuide = true
					}
				}
				}
			})
			})
		} else {
			this.openId = localStorage.openId
			let isEmployee = window.localStorage.getItem('isEmployee')
			let allAxiox = ''
			if (isEmployee) {
				let data = {
					openId: this.openId,
					returnurl: encodeURIComponent(this.returnurl)
				}
				allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
			} else {
				let data = {
					openid: this.openId,
					returnurl: encodeURIComponent(this.returnurl)
				}
				allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
			}

			if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}


			allAxiox.then(msg => {
				console.log(msg, 'getDoctor')
				if (msg.isSuccess) {
					if (msg.data.status === 2) {
						//window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
					} else if (msg.data.status === 3) {
						//window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
					} else {
						if (msg.data.isFollowed) {
							// 获取用户信息
							this.getUserInfo()
						} else {
							// this.$commonJs.closeWindow()
							this.showGuide = true
						}
					}
				}
			})
		}
		}
		this.searchHCPInfo()
		/*if (this.isHcp) {
			this.showPage = true
			this.getAllDepartmen()
			this.getAllIns()
			this.getAllBrand()
			this.getAllDoc()
		} else {
			this.showPage = false
			this.$router.push('/myCustomErrPage')
		}*/
		// alert("created");
		// this.timer=setInterval(()=>{
		// 	alert("定时器调用了");
		// 	getAllDoc();
		// },10000)
  	},
	methods: {
		searchHCPInfo () {
			this.$axiox.get('/api/wechat/ArticlePush/searchHCPInfo?openId=' + this.openId).then(res => {
				console.log(res, 'searchHCPInfo')
				if (res === '1' || res === 1) {
					this.isHcp = false
					this.showPage = false
					this.$router.push('/noPermission')
				} else {
					this.isHcp = true
					this.showPage = true
					this.getAllDepartmen()
					this.getAllIns()
					this.getAllBrand()
					this.getAllDoc()
				}
			})
		},
		getAllDepartmen () {
      		this.$axiox.get('/api/wechat/ArticlePush/queryDepartmen').then(p => {
        		this.allDepartmen = p
      		})
		},
		getAllIns () {
      		this.$axiox.get('/api/wechat/ArticlePush/queryIns').then(p => {
        		this.allIns = p
      		})
		},
    	getAllBrand () {
      		this.$axiox.get('/api/wechat/ArticlePush/queryBrand').then(p => {
        		this.allBrand = p
      		})
		},
    	getAllDoc () {
      		this.$axiox.get('/api/wechat/ArticlePush/searchDocInfo').then(p => {
        		this.allDocInfo = p
				// this.allDocInfo.sort((a, b) => {
          		// 	return b.score - a.score;
        		// });
				for (let i = 0; i < this.allDocInfo.length; i++) {
					if (i >= 0 && i <= 4) {
						if ('0' !== this.allDocInfo[i].score) {
							this.allDocInfo[i].nbc = 1
						} else {
							this.allDocInfo[i].nbc = 0
						}
					} else {
						this.allDocInfo[i].nbc = 0
						if (i > 4) {
							if (this.allDocInfo[4].nbc === 1) {
								if (this.allDocInfo[4].score === this.allDocInfo[i].score) {
									this.allDocInfo[i].nbc = 1
								}
							}
						}
					}
				}
      		})
		},
		changeSelect (event) {
			var ins = this.cateModel.insId
			var dep = this.cateModel.departmenId
			var prd = this.cateModel.productId
			this.$axiox.get('/api/wechat/ArticlePush/searchDocInfo').then(p => {
				this.allDocInfo = p
				if (prd !== '-1') {
					this.allDocInfo = this.allDocInfo.filter(val => val.brandName == prd)
				}
				if (ins !== '-1') {
					this.allDocInfo = this.allDocInfo.filter(val => val.hospitalName == ins)
				}
				if (dep !== '-1') {
					this.allDocInfo = this.allDocInfo.filter(val => val.department == dep)
				}
				// this.allDocInfo.sort((a, b) => {
          		// 	return b.score - a.score;
        		// });
				for (let i = 0; i < this.allDocInfo.length; i++) {
					if (i >= 0 && i <= 4) {
						if ('0' !== this.allDocInfo[i].score) {
							this.allDocInfo[i].nbc = 1
						} else {
							this.allDocInfo[i].nbc = 0
						}
					} else {
						this.allDocInfo[i].nbc = 0
						if (i > 4) {
							if (this.allDocInfo[4].nbc === 1) {
								if (this.allDocInfo[4].score === this.allDocInfo[i].score) {
									this.allDocInfo[i].nbc = 1
								}
							}
						}
					}
				}
      		})
    	},
		articalPush(object) {
			window.localStorage.setItem('DocCode', object.docCode)
			window.localStorage.setItem('DocName', object.docName)
			window.localStorage.setItem('DocOpenId', object.docOpenId)
			this.$router.push('/articlePushManage')
		},
		// 获取用户信息
		getUserInfo () {
			let isEmployee = window.localStorage.getItem('isEmployee')
			let requestUrl2 = ''
			if (isEmployee) {
				requestUrl2 = this.$axiox.getNoRes('/Login/EmployeeWxUserInfo?openId=' + this.openId)
			} else {
				let data = {
					openId: this.openId
				}
				requestUrl2 = this.$axiox.postNoRes('/Login/WxUserInfo', data)
			}
			requestUrl2.then(msg => {
				console.log(msg, 'msg')
				if (msg.isSuccess) {
					this.userInfo = msg.data
				}
			})
		}
	},
	activated() {
    	//alert("定时器开启");
		this.timer=setInterval(()=>{
			//alert("定时器调用了");
			this.getAllDoc();
			//this.$forceUpdate();
		},20000)
  	},
	deactivated() {
    	//alert("定时器关闭");
		clearInterval(this.timer);
  	}
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/login/myCustomCollections.vue